<script setup>
import ContentSubheaderPage from '@/components/content/ContentSubheaderPage.vue'
import { onMounted, ref } from 'vue'
import { useOurLossesStore } from '@/store/ourLosses'
import { useRouter } from 'vue-router'

const router = useRouter()
const ourLossesStore = useOurLossesStore()

const ourLossId = ref(0)
const ourLossData = ref({})

onMounted(async () => {
    ourLossId.value = Number(router.currentRoute.value.params.id)

    await ourLossesStore.getSingleLoss(ourLossId.value)
    ourLossData.value = ourLossesStore.singleLoss

    await ourLossesStore.incrementLossViews(ourLossId.value)
})
</script>

<template>
    <content-subheader-page
        class="our-losses-page-content-subheader"
        :text="`Наши потери. ${ourLossData.name}`"
    />
    <div class="our-losses-date">
        <img
            src="/svg/calendar_date.svg"
            alt="Календарь"
        />
        {{
            new Date(ourLossData.creation_time).toLocaleDateString('ru-RU', {
                day: 'numeric',
                month: 'long',
                year: 'numeric'
            })
        }}
    </div>
    <div class="our-losses-main-content" v-html="ourLossData.text">
    </div>
</template>

<style lang="scss" scoped>
.our-losses-page-content-subheader {
    text-align: left;

    @media screen and (max-width: 767px) {
        font-size: 28px;
        line-height: 36px;
        text-align: left;
    }
}

.our-losses-date {
    display: flex;
    align-items: center;
    gap: 10px;
    color: #a2a2a2;
    font-size: 20px;
    line-height: 28px;
    margin-top: 20px;
}

.our-losses-main-content {
    margin-top: 25px;
    font-size: 20px;
    line-height: 28px;
    text-align: left;

    ul {
        margin-top: 15px;
        list-style-position: inside;
        color: #001fa3;
    }
}
</style>
